module.exports = __webpack_public_path__ + "assets/profile-icon.1954e28723f6c5448c39e358e70400ee.svg";